import React, { useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import BreadCrumb from "../../common/breadcrumb";
import ServicesSingleMain from "./services-single";
import SEO from "../../../data/seo";
import HeaderTwo from "../../../layout/headers/header-two";
import FooterTwo from "../../../layout/footers/footer-two";
import { getServices } from "../../../utils/cms.utils";


const ServicesDetails = () => {
    const { id } = useParams();
    const navigate = useNavigate();

    const [services, setServices] = useState([]);

    useEffect(() => {
        const data = getServices();
        const sorted = Array.isArray(data)
            ? [...data].sort((a, b) => (a.orderNo ?? 0) - (b.orderNo ?? 0))
            : [];
        setServices(sorted);
    }, []);

    const singleData = services.find(
        (service) => String(service.id) === String(id)
    );

    useEffect(() => {
        if (services.length > 0 && !singleData) {
            navigate("/404-error", { replace: true });
        }
    }, [services, singleData, navigate]);

    if (!services.length || !singleData) return null;

    return (
        <>
            <SEO pageTitle={singleData.titleEn} />
            <HeaderTwo />
            <BreadCrumb
                title={singleData.titleEn}
                items={[
                    { label: "Services", to: "/services" },
                    { label: singleData.titleEn },
                ]}
            />
            <ServicesSingleMain
                singleData={singleData}
                services={services}
            />
            <FooterTwo />
        </>
    );
};


export default ServicesDetails;
